import PropTypes from 'prop-types'
import React from 'react'

import Header from './header'
import Nav from './nav'

import styled from 'styled-components'

const CustomHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  @media (min-width: 910px) {
    padding-top: 30px;
  }
  ${({ image, gradient }) => image ? `
    background-image: url(${image})${gradient ? `, linear-gradient(96.64deg, #061621 0%, #21373C 99.64%);` : ';'};
    background-size: 100% 100%;
    background-repeat: no-repeat;
  `
  : 'background: linear-gradient(96.64deg, #061621 0%, #21373C 99.64%);'}
`

const HeaderSection = ({ siteTitle, header = {} }) => (
  <>
    <CustomHeaderSection image={header.image} gradient={header.gradient}>
      <Nav />
      <Header header={header} />
    </CustomHeaderSection>
  </>
)

HeaderSection.propTypes = {
  siteTitle: PropTypes.string
}

HeaderSection.defaultProps = {
  siteTitle: ''
}

export default HeaderSection
